var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-skeleton"},[_c('SkeletonAnimate',{staticClass:"skelete-1 skekete"}),_c('SkeletonAnimate',{staticClass:"skelete-2 skekete mt-40"}),_c('SkeletonAnimate',{staticClass:"skelete-3 skekete"}),_c('SkeletonAnimate',{staticClass:"skelete-4 skekete"}),_c('SkeletonAnimate',{staticClass:"skelete-3 skekete"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }